var _rect, _path, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 10,
    viewBox: "0 0 22 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 1,
    fill: "#B7B7B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43303 2.75C5.24058 2.41667 4.75946 2.41667 4.56701 2.75L2.43305 6.44612C2.2406 6.77945 2.48116 7.19612 2.86607 7.19612L7.13397 7.19612C7.51887 7.19612 7.75944 6.77945 7.56699 6.44612L5.43303 2.75Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.433 7.44629C17.2406 7.77962 16.7595 7.77962 16.567 7.44629L14.4331 3.75017C14.2406 3.41684 14.4812 3.00017 14.8661 3.00017L19.134 3.00017C19.5189 3.00017 19.7594 3.41684 19.567 3.75017L17.433 7.44629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.f0d29856504b0834237c13538c2dd070.svg";
export { ForwardRef as ReactComponent };